import HipchatChevronDownIcon from '@atlaskit/icon/glyph/hipchat/chevron-down';
import HipchatChevronUpIcon from '@atlaskit/icon/glyph/hipchat/chevron-up';
import styled from 'styled-components';
import { SectionParent } from '../../components/StyledComponents';
import React from 'react';

const TopHeaderWrapper = styled.div`
  display: flex;
  /* box-shadow: 0 1px 2px 0 #232a57; */
  background-color: #f8fafd;
  cursor: pointer;
  justify-content: center;
  border-bottom: solid 1px #232a57;
`;
const TopSection = styled.div`
  display: grid;
  text-align: center;
  align-items: center;
  padding: 3rem;
  margin-right: 4rem;
  font-size: 36px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #151828;
  @media (max-width: 520px) {
    font-size: 24px;
    padding: 1.5rem;
  }
`;

const SectionTwo = styled(SectionParent)`
  background-repeat: no-repeat;
  background-color: #ffffff;
  padding-top: 3rem !important;
  padding-bottom: 5rem !important;
  animation-name: ex;
  animation-duration: 1s;
  @keyframes ex {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
  @media (max-width: 520px) {
    padding-top: 2rem !important;
    /* padding-bottom: 5rem !important; */
  }
  width: 100%;
  display: grid;
  justify-items: center;
`;

const FaqSection = styled.div`
  /* padding: 1rem; */
  width: 70%;
  border-radius: 5px;
  :hover {
    background: #f3f2f296;
  }
  @media (max-width: 520px) {
    width: 90%;
  }
`;

const FaqHeader = styled.div`
  cursor: pointer;
  display: grid;
  justify-content: center;
  position: relative;
  padding: 1rem;
  padding-right: 0rem;
  padding-bottom: 0rem;
  grid-template-columns: repeat(12, 1fr);
`;

const QuestionSection = styled.div`
  font-size: 21px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #151828;
  display: grid;
  grid-column: span 11;
  align-items: center;
  justify-content: start;
  padding-bottom: 1rem;
  @media (max-width: 520px) {
    font-size: 18px;
  }
`;

const ArrowSection = styled.div`
  display: grid;
  grid-column: span 1;
  justify-self: end;
  position: relative;
  cursor: pointer;
  width: 5rem;
`;
const AnswerContainer = styled.div`
  display: grid;
  /* grid-column: span 2; */
  animation: example3;
  animation-duration: 1s;
  padding-left: 1rem;
  padding-bottom: 1rem;
  animation-timing-function: ease-in-out;
  @keyframes example3 {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
`;
const AnswerSection = styled.div`
  display: grid;
  grid-column: span 2;
  font-size: 18px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #626679;
  width: 80%;
  padding-bottom: 1rem;
  @media (max-width: 520px) {
    font-size: 14px;
  }
`;

const BorderBottom = styled.div`
  display: grid;
  grid-column: span 2;
  height: 1px;
  width: 60%;
  border: solid 1px #979797;
  margin-bottom: 1rem;
`;

const ArrowHolder = styled.div`
  width: fit-content;
  display: grid;
  position: absolute;
  top: 0;
  left: 0;
`;
export default class PricingSectionFive extends React.Component<any, any> {
  constructor(props: any) {
    super(props);
    this.state = {
      selected: -1,
      open: false,
    };
  }

  displayFaq = (index: number) => {
    if (index === this.state.selected) {
      this.setState({
        selected: -1,
      });
    } else {
      this.setState({
        selected: index,
      });
    }
  };
  displaySection = () => {
    this.setState({ open: !this.state.open });
  };
  render() {
    return (
      <div>
        <TopHeaderWrapper onClick={() => this.displaySection()}>
          <TopSection>{this.props?.messages?.PricingPageFAQTitle}</TopSection>
          <ArrowSection style={{ alignSelf: 'center', marginTop: '-3rem' }}>
            <ArrowHolder className={this.state.open ? 'rotate' : 'reverse'}>
              <HipchatChevronDownIcon label="arrow" size="xlarge" />
            </ArrowHolder>
          </ArrowSection>
        </TopHeaderWrapper>

        {this.state.open && (
          <SectionTwo>
            <FaqSection>
              <FaqHeader onClick={() => this.displayFaq(1)}>
                <QuestionSection>
                  {this.props?.messages?.PricingPageFAQFreeQuestion}
                </QuestionSection>
                <ArrowSection>
                  <ArrowHolder
                    className={this.state.selected === 1 ? 'rotate' : 'reverse'}
                  >
                    <HipchatChevronDownIcon label="arrow" size="large" />
                  </ArrowHolder>
                  {/* )} */}
                </ArrowSection>
              </FaqHeader>
              {this.state.selected === 1 && (
                <AnswerContainer>
                  <AnswerSection>
                    {this.props?.messages?.PricingPageFAQFreeAns}
                  </AnswerSection>
                  <BorderBottom />
                </AnswerContainer>
              )}
            </FaqSection>
            <FaqSection>
              <FaqHeader onClick={() => this.displayFaq(2)}>
                <QuestionSection>
                  {this.props?.messages?.PricingPageFAQLicenseQuestion}
                </QuestionSection>
                <ArrowSection>
                  <ArrowHolder
                    className={this.state.selected === 2 ? 'rotate' : 'reverse'}
                  >
                    <HipchatChevronDownIcon label="arrow" size="large" />
                  </ArrowHolder>
                </ArrowSection>
              </FaqHeader>
              {this.state.selected === 2 && (
                <AnswerContainer>
                  <AnswerSection>
                    {this.props?.messages?.PricingPageFAQLicenseAns}
                  </AnswerSection>
                  <BorderBottom />
                </AnswerContainer>
              )}
            </FaqSection>
            <FaqSection>
              <FaqHeader onClick={() => this.displayFaq(3)}>
                <QuestionSection>
                  {this.props?.messages?.PricingPageFAQTrialQuestion}{' '}
                </QuestionSection>
                <ArrowSection>
                  <ArrowHolder
                    className={this.state.selected === 3 ? 'rotate' : 'reverse'}
                  >
                    <HipchatChevronDownIcon label="arrow" size="large" />
                  </ArrowHolder>
                </ArrowSection>
              </FaqHeader>
              {this.state.selected === 3 && (
                <AnswerContainer>
                  <AnswerSection>
                    {this.props?.messages?.PricingPageFAQTrialAns}
                  </AnswerSection>
                  <BorderBottom />
                </AnswerContainer>
              )}
            </FaqSection>

            <FaqSection>
              <FaqHeader onClick={() => this.displayFaq(4)}>
                <QuestionSection>
                  {this.props?.messages?.PricingPageFAQUpgradeQuestion}
                </QuestionSection>
                <ArrowSection>
                  <ArrowHolder
                    className={this.state.selected === 4 ? 'rotate' : 'reverse'}
                  >
                    <HipchatChevronDownIcon label="arrow" size="large" />
                  </ArrowHolder>
                </ArrowSection>
              </FaqHeader>
              {this.state.selected === 4 && (
                <AnswerContainer>
                  <AnswerSection>
                    {this.props?.messages?.PricingPageFAQUpgradeAns}
                  </AnswerSection>
                  <BorderBottom />
                </AnswerContainer>
              )}
            </FaqSection>

            <FaqSection>
              {' '}
              <FaqHeader onClick={() => this.displayFaq(5)}>
                <QuestionSection>
                  {this.props?.messages?.PricingPageFAQDeviceSupportQuestion}
                </QuestionSection>
                <ArrowSection>
                  <ArrowHolder
                    className={this.state.selected === 5 ? 'rotate' : 'reverse'}
                  >
                    <HipchatChevronDownIcon label="arrow" size="large" />
                  </ArrowHolder>
                </ArrowSection>
              </FaqHeader>
              {this.state.selected === 5 && (
                <AnswerContainer>
                  <AnswerSection>
                    {this.props?.messages?.PricingPageFAQDeviceSupportAns}
                  </AnswerSection>
                  <BorderBottom />
                </AnswerContainer>
              )}
            </FaqSection>

            <FaqSection>
              {' '}
              <FaqHeader onClick={() => this.displayFaq(6)}>
                <QuestionSection>
                  {this.props?.messages?.PricingPageFAQMinDeviceQuestion}
                </QuestionSection>
                <ArrowSection>
                  <ArrowHolder
                    className={this.state.selected === 6 ? 'rotate' : 'reverse'}
                  >
                    <HipchatChevronDownIcon label="arrow" size="large" />
                  </ArrowHolder>
                </ArrowSection>
              </FaqHeader>
              {this.state.selected === 6 && (
                <AnswerContainer>
                  <AnswerSection>
                    {this.props?.messages?.PricingPageFAQMinDeviceAns}
                  </AnswerSection>
                  <BorderBottom />
                </AnswerContainer>
              )}
            </FaqSection>

            <FaqSection>
              {' '}
              <FaqHeader onClick={() => this.displayFaq(7)}>
                <QuestionSection>
                  {this.props?.messages?.PricingPageFAQPartnerQuestion}
                </QuestionSection>
                <ArrowSection>
                  <ArrowHolder
                    className={this.state.selected === 7 ? 'rotate' : 'reverse'}
                  >
                    <HipchatChevronDownIcon label="arrow" size="large" />
                  </ArrowHolder>
                </ArrowSection>
              </FaqHeader>
              {this.state.selected === 7 && (
                <AnswerContainer>
                  <AnswerSection>
                    {this.props?.messages?.PricingPageFAQPartnerAns}
                  </AnswerSection>
                  <BorderBottom />
                </AnswerContainer>
              )}
            </FaqSection>

            <FaqSection>
              {' '}
              <FaqHeader onClick={() => this.displayFaq(8)}>
                <QuestionSection>
                  {this.props?.messages?.PricingPageFAQSupportQuestion}
                </QuestionSection>
                <ArrowSection>
                  <ArrowHolder
                    className={this.state.selected === 8 ? 'rotate' : 'reverse'}
                  >
                    <HipchatChevronDownIcon label="arrow" size="large" />
                  </ArrowHolder>
                </ArrowSection>
              </FaqHeader>
              {this.state.selected === 8 && (
                <AnswerContainer>
                  <AnswerSection>
                    {this.props?.messages?.PricingPageFAQSupportAns}
                  </AnswerSection>
                  <BorderBottom />
                </AnswerContainer>
              )}
            </FaqSection>

            <FaqSection>
              {' '}
              <FaqHeader onClick={() => this.displayFaq(9)}>
                <QuestionSection>
                  {this.props?.messages?.PricingPageFAQCancelQuestion}
                </QuestionSection>
                <ArrowSection>
                  <ArrowHolder
                    className={this.state.selected === 9 ? 'rotate' : 'reverse'}
                  >
                    <HipchatChevronDownIcon label="arrow" size="large" />
                  </ArrowHolder>
                </ArrowSection>
              </FaqHeader>
              {this.state.selected === 9 && (
                <AnswerContainer>
                  <AnswerSection>
                    {this.props?.messages?.PricingPageFAQCancelAns}
                  </AnswerSection>
                  <BorderBottom />
                </AnswerContainer>
              )}
            </FaqSection>

            <FaqSection>
              {' '}
              <FaqHeader onClick={() => this.displayFaq(10)}>
                <QuestionSection>
                  {this.props?.messages?.PricingPageFAQTrainingQuestion}
                </QuestionSection>
                <ArrowSection>
                  <ArrowHolder
                    className={
                      this.state.selected === 10 ? 'rotate' : 'reverse'
                    }
                  >
                    <HipchatChevronDownIcon label="arrow" size="large" />
                  </ArrowHolder>
                </ArrowSection>
              </FaqHeader>
              {this.state.selected === 10 && (
                <AnswerContainer>
                  <AnswerSection>
                    {this.props?.messages?.PricingPageFAQTrainingAns}
                  </AnswerSection>
                  <BorderBottom />
                </AnswerContainer>
              )}
            </FaqSection>
          </SectionTwo>
        )}
      </div>
    );
  }
}
